/* Tarelia — interacciones propias del tema (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ta-reveal:not(.ta-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ta-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ta-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGalerias() {
    document.querySelectorAll('[data-ta-galeria]').forEach(function (gal) {
      if (gal.dataset.taListo) return;
      gal.dataset.taListo = '1';
      var principal = gal.querySelector('[data-ta-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-ta-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.dataset.src;
            principal.srcset = btn.dataset.srcset || '';
            principal.alt = btn.dataset.alt || '';
            principal.style.opacity = '1';
          }, 150);
          gal.querySelectorAll('[data-ta-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function formatoDinero(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var sinCentavos = partes[1] === '00' ? miles : miles + '.' + partes[1];
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles)
      .replace(/\{\{\s*amount\s*\}\}/, sinCentavos)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, sinCentavos);
  }

  function initProducto() {
    document.querySelectorAll('[data-ta-producto]').forEach(function (raiz) {
      if (raiz.dataset.taListo) return;
      raiz.dataset.taListo = '1';
      var datos = raiz.querySelector('[data-ta-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = raiz.dataset.formato;
      var inputId = raiz.querySelectorAll('input[name="id"]');
      var precio = raiz.querySelectorAll('[data-ta-precio]');
      var antes = raiz.querySelectorAll('[data-ta-antes]');
      var botones = raiz.querySelectorAll('[data-ta-boton]');
      var agotado = raiz.querySelector('[data-ta-agotado]');

      function actualizar() {
        var seleccion = [];
        raiz.querySelectorAll('[data-ta-opcion]').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          if (marcado) seleccion.push(marcado.value);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === seleccion[i]; });
        });
        botones.forEach(function (b) { b.disabled = !v || !v.available; });
        if (agotado) agotado.classList.toggle('is-visible', !v || !v.available);
        if (!v) return;
        inputId.forEach(function (i) { i.value = v.id; });
        precio.forEach(function (p) { p.textContent = formatoDinero(v.price, formato); });
        antes.forEach(function (a) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            a.textContent = formatoDinero(v.compare_at_price, formato);
            a.hidden = false;
          } else { a.hidden = true; }
        });
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      raiz.querySelectorAll('[data-ta-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });

      raiz.querySelectorAll('[data-ta-cantidad]').forEach(function (caja) {
        var input = caja.querySelector('input');
        caja.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n = b.dataset.paso === 'mas' ? n + 1 : Math.max(1, n - 1);
            input.value = n;
            raiz.querySelectorAll('input[name="quantity"]').forEach(function (q) { q.value = n; });
          });
        });
        input.addEventListener('change', function () {
          var n = Math.max(1, parseInt(input.value, 10) || 1);
          input.value = n;
          raiz.querySelectorAll('input[name="quantity"]').forEach(function (q) { q.value = n; });
        });
      });

      // Barra fija en celular: aparece cuando el botón principal sale de pantalla
      var barra = raiz.querySelector('[data-ta-barra]');
      var ancla = raiz.querySelector('[data-ta-ancla-compra]');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', visible);
          document.body.classList.toggle('ta-barra-activa', visible);
        }).observe(ancla);
      }
    });
  }

  function init() {
    initReveal();
    initGalerias();
    initProducto();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
